import { render, staticRenderFns } from "./OabotCard.vue?vue&type=template&id=5c5cbcc6&scoped=true&"
import script from "./OabotCard.vue?vue&type=script&lang=js&"
export * from "./OabotCard.vue?vue&type=script&lang=js&"
import style0 from "./OabotCard.vue?vue&type=style&index=0&id=5c5cbcc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5cbcc6",
  null
  
)

export default component.exports